<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M40.34 35.82l-2.74-5.36a7.15 7.15 0 01-.76-3.17v-7.66A12.72 12.72 0 0025.5 7.09V5.5a1.5 1.5 0 00-3 0v1.59a12.72 12.72 0 00-11.34 12.54v7.66a7.15 7.15 0 01-.76 3.17l-2.74 5.36a1.52 1.52 0 00.06 1.46A1.49 1.49 0 009 38h7.87a7.24 7.24 0 0014.26 0H39a1.49 1.49 0 001.28-.72 1.52 1.52 0 00.06-1.46zM24 41a4.24 4.24 0 01-4-3h8a4.24 4.24 0 01-4 3zm-12.55-6l1.62-3.18a9.74 9.74 0 00.69-1.82H20a1 1 0 000-2h-5.88V19.63a9.84 9.84 0 0119.68 0v7.66a10.08 10.08 0 001.09 4.53L36.55 35z"/></svg>